import React from 'react';
import '../styles/HotelFacilities.css';
import "../styles/style.css"
import '../styles/HeroSearchSection.css';
import '../bbkandy/css/hotale-style-custom.css'
import '../bbkandy/css/style-core.css'
import '../bbkandy/css/style.css'
import '../bbkandy/css/tourmaster-global-style-custom.css'
import '../bbkandy/css/tourmaster-room-style-custom.css'
import '../bbkandy/css/custom.css'
import '../styles/Icon.css'

const HotelFacilitiesSection = () => {
    return (
        <div className="hotel-facilities-section " style={{ padding: '50px 20px 18px 20px' }}>
            <div className="hotel-facilities-wrapper">
                <div className="hotel-facilities-title hotale-additional-font">
                    <h3>Hotel Facilities</h3>
                </div>
                <div className="hotel-facilities-subtext">
                    <p>Relax, indulge, and savor our luxurious hotel amenities to unwind.</p>
                </div>

                <div className="facility-grid">
                    {/* Facility 1: Parking */}
                    <div className="facility-item fade-in">
                        <img src="/bbkandy/upload/Group-40.png" alt="Parking" className="facility-icon" />
                        <p>Parking</p>
                    </div>

                    {/* Facility 2: Swimming Pool */}
                    <div className="facility-item fade-in">
                        <i className="gdl-travel-swimming-pool-1 facility-icon icon-font gdlr-icon-item-icon" />
                        <p>Swimming Pool</p>
                    </div>

                    {/* Facility 3: Free Wifi */}
                    <div className="facility-item fade-in">
                        <i className="gdl-travel-wifi-signal-2 facility-icon icon-font" />
                        <p>Free Wifi</p>
                    </div>

                    {/* Facility 4: Breakfast */}
                    <div className="facility-item fade-in">
                        <i className="gdl-travel-dish-1 facility-icon icon-font" />
                        <p>Breakfast</p>
                    </div>

                    {/* Facility 5: Workspace */}
                    <div className="facility-item fade-in">
                        <i className="gdl-travel-improvement facility-icon icon-font" />
                        <p>Workspace</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotelFacilitiesSection;
